import type { ExperimentTypes } from "./experimentType";

export type DdcExperimentIdType = "experiment-navigation-items";

export const DdcExperimentList: ExperimentTypes<DdcExperimentIdType>[] = [
  {
    id: "experiment-navigation-items",
    name: "Experiment Navigation Items",
    description: "This is the experiment navigation items."
  }
];
